/**
 * vendor
 */
import React, { useEffect, useRef } from 'react';

/**
 * PALTFORM MODULE
 */
import AlertService from '@shared/services/base/alerts/AlertService';

function AlertsLoad() {
  const alertServiceRef = useRef(null);
  const componentLikeRef = useRef(null);

  useEffect(() => {
    // Create component-like object for service
    const componentLike = {
      setState: () => {},
      state: {}
    };

    componentLikeRef.current = componentLike;
    alertServiceRef.current = new AlertService(componentLike);

    alertServiceRef.current.registerAlertEvents(componentLike, alertServiceRef.current);

    return () => {
      if (alertServiceRef.current) {
        alertServiceRef.current.removeAlertEvents();
      }
    };
  }, []);

  return (<></>);
}

export default AlertsLoad;
